import { axiosBasic } from "../../../api/axios";
import { config } from "../../../api/endPoints";

const { AppUser } = config.REST_API;

const omitEmptyParams = (obj) => {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === undefined || v === null || v === "") continue;
    out[k] = v;
  }
  return out;
};

const fetchUsersExportBlob = async (path, query) => {
  const res = await axiosBasic.get(path, {
    params: omitEmptyParams(query),
    responseType: "blob",
  });
  const blob = res.data;
  if (blob instanceof Blob && blob.type && blob.type.includes("application/json")) {
    const text = await blob.text();
    try {
      const json = JSON.parse(text);
      if (json && json.success === false) {
        throw new Error(json.message || "Export failed");
      }
    } catch (e) {
      if (e instanceof Error && e.message !== "Export failed") throw e;
      throw new Error(text || "Export failed");
    }
  }
  return blob;
};

/**
 * Build query for AppUser export endpoints (same filters as GetUsers).
 * @param {{ officeId?: number|string, departmentId?: number|string, isActive?: boolean, search?: string }} filters
 */
export const buildUsersExportQuery = (filters) => {
  const q = {
    officeId: Number(filters.officeId) || 0,
    departmentId: Number(filters.departmentId) || 0,
    isActive: filters.isActive !== false,
  };
  const search = String(filters.search ?? "").trim();
  if (search) q.search = search;
  return q;
};

export const fetchUsersExportExcel = (query) => fetchUsersExportBlob(AppUser.ExportUsers, query);

export const fetchUsersExportCsv = (query) => fetchUsersExportBlob(AppUser.ExportUsersCsv, query);

export const fetchUsersExportPdf = (query) => fetchUsersExportBlob(AppUser.ExportUsersPdf, query);

export const usersExportBasename = () => {
  const stamp = new Date().toISOString().slice(0, 10);
  return `employees-${stamp}`;
};

export const triggerBlobDownload = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
